import { Store } from '@reduxjs/toolkit';
import countries from 'i18n-iso-countries';
import { trace } from '../setup/trace';
import { isoCountries } from './isoCountries';
import { DEFAULT_LOCALE, getSupportedLocale as defaultGetSupportedLocale } from './lang';
import { displayMessagesFetched, localeChanged } from './langSlice';
import { momentLocaleImports } from './momentLocales';

const importDisplayMessages = async (locale: string) =>
    (await import(`../../features/translations/${locale}.json`)).default;

const importMomentLocales = async (countryPartOfLocale: string) => {
    if (countryPartOfLocale in momentLocaleImports) {
        await momentLocaleImports[countryPartOfLocale as keyof typeof momentLocaleImports]();
    }
};

export const importIsoCountries = async (localeCode: string) => {
    if (localeCode in isoCountries) {
        try {
            const { default: data } = await isoCountries[localeCode]();
            countries.registerLocale(data);
        } catch (_e) {}
    }
};

export const configureFetchDisplayMessages =
    (store: Store, fetchDisplayMessages = importDisplayMessages, getSupportedLocale = defaultGetSupportedLocale) =>
    async (locale: string) => {
        if (!locale) {
            return Promise.reject();
        }

        const supportedLocale = getSupportedLocale(locale);

        try {
            const countryPartOfLocale = locale.substring(0, 2);

            await importMomentLocales(countryPartOfLocale);

            const displayMessages = await fetchDisplayMessages(supportedLocale);
            trace(`Display messages fetched for "${supportedLocale}"`);
            store.dispatch(displayMessagesFetched({ locale: supportedLocale, displayMessages }));
        } catch (error: unknown) {
            trace('failed to fetch display messages', error);
            store.dispatch(localeChanged(DEFAULT_LOCALE));
        }
    };
